import { BLOCK_CONFIG } from '../../constants/MenuConstants.js';

export const addRecursiveMenuBlock = (editor) => {
    editor.BlockManager.add('recursive-menu', BLOCK_CONFIG);
};